import { useLocation, Navigate } from 'react-router-dom';
import { SignUpCompleteForm } from '@/components/elements/SignUpCompleteForm';
import { ROUTE_PATH } from '@/constants/routes';

interface LocationState {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

export const SignUpComplete = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;

  // stateが存在しない場合はサインアップページにリダイレクト
  if (!state || !state.email || !state.firstName || !state.lastName || !state.password) {
    return <Navigate to={ROUTE_PATH.SIGN_UP} replace />;
  }

  return (
    <div className="page p-auth page_a2">
      <main className="page__main">
        <div className="page__content">
          <section className="l-section">
            <div className="l-section__line">
              <div className="l-container">
                <div className="l-hero">
                  <img
                    className="l-hero__img"
                    src="/Common_Title.jpg"
                    alt="LOUNGE RESERVATION"
                  />
                </div>
                <div className="l-grid">
                  <SignUpCompleteForm
                    email={state.email}
                    firstName={state.firstName}
                    lastName={state.lastName}
                    password={state.password}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};
